import React, { ReactNode } from 'react';

interface Props {
  menuOpen: boolean;
  onToggle: () => void;
  sync?: ReactNode;
}

export const Navbar: React.FC<Props> = ({ menuOpen, onToggle, sync }) => {
  return (
    <div>
      <div
        className="navbar is-dark"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <div className="navbar-item">
            <i className="material-icons">menu_book</i>
            <div className="ml-1">Progressive bookmarks</div>
          </div>
          <a
            role="button"
            className={`navbar-burger is-hidden-tablet${menuOpen ? ' is-active' : ''}`}
            aria-label="menu"
            aria-expanded={menuOpen}
            onClick={onToggle}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
      </div>
      {sync && (
        <div className="section py-2 mb-0">
          <div className="container">{sync}</div>
        </div>
      )}
    </div>
  );
};
